export const routingInfo = Object.freeze({
    TERMINAL: {
        id: 1,
        url: "terminal"
    },
    MESURMENT: {
        id: 2,
        url: "mersument"
    },
    SETINGS: {
        id: 3,
        url: "settings"
    },
    SESSION_INFO: {
        id: 4,
        url: "sessioninfo"
    },
    MESURMENT_INFO: {
        id: 5,
        url: "mesurmentinfo"
    },
    SUPPORT: {
        id: 6,
        url: "support"
    },
    SANDBOX: {
        id: 7,
        url: "sandbox"
    }
});
export const customerList = Object.freeze([
    {
        name: "Jotio s.r.o.",
        value: {
            name: "Jotio s.r.o.",
            clientID: 0,
            contatInfo: {
                email: "someone@jotio.tech",
                phone: "333 555 999",
                address: ""
            },
        },
    },
    {
        name: "České Radiokomunikace a.s.",
        value: {
            name: "České Radiokomunikace a.s.",
            clientID: 0,
            contatInfo: {
                email: "someone@cra.cz",
                phone: "333 555 999",
                address: ""
            },
        },
    },
    {
        name: "examle 0",
        value: {
            name: "exam0",
            clientID: 1,
            contatInfo: {
                email: "x@y.tech",
                phone: "333 555 999",
                address: ""
            },
        },
    },
    {
        name: "examle 1",
        value: {
            name: "exam1",
            clientID: 2,
            contatInfo: {
                email: "x@y.tech",
                phone: "333 555 999",
                address: ""
            },
        },
    },
]);
export const PORT_STATE = Object.freeze({
    DISCONNECTED_NO_REF: {
        // NOT USED
        text: "Disconnected",
        color: "grey",
    },
    DISCONNECTED_REF: {
        text: "Disconnected",
        color: "red",
    },
    CONNECTED_NOT_ACT: {
        text: "Inactive",
        color: "yellow",
    },
    CONNECTED_ACT: {
        text: "Active",
        color: "green",
    },
});
export const USER_ROLE = Object.freeze({
    DEV: {
        id: 1,
        displayedName: 'DEV',
        iconName: 'code',
        avalibleDialogs: [
            /* routingInfo.TERMINAL, */ routingInfo.MESURMENT, routingInfo.SETINGS, routingInfo.SESSION_INFO, routingInfo.MESURMENT_INFO, routingInfo.SUPPORT
        ],
        activeDialogs: [
            routingInfo.MESURMENT, routingInfo.SETINGS, routingInfo.SESSION_INFO, routingInfo.MESURMENT_INFO,
        ]
    },
    TECHNICIAN: {
        id: 2,
        displayedName: 'Technik',
        iconName: 'build',
        avalibleDialogs: [
            routingInfo.MESURMENT, routingInfo.SETINGS, routingInfo.SESSION_INFO, routingInfo.SUPPORT
        ],
        activeDialogs: [
            routingInfo.MESURMENT, routingInfo.SETINGS
        ]
    },
    ASISTENT: {
        id: 3,
        displayedName: 'Asistent',
        iconName: 'edit_calendar',
        avalibleDialogs: [
            routingInfo.SETINGS, routingInfo.SESSION_INFO, routingInfo.SUPPORT
        ],
        activeDialogs: [
            routingInfo.SESSION_INFO, routingInfo.SETINGS
        ]
    },
    MANAGER: {
        id: 4,
        displayedName: 'Vedoucí',
        iconName: 'receipt_long',
        avalibleDialogs: [
            routingInfo.SETINGS, routingInfo.SESSION_INFO, routingInfo.MESURMENT_INFO, routingInfo.SUPPORT
        ],
        activeDialogs: [
            routingInfo.SESSION_INFO, routingInfo.MESURMENT_INFO,
        ]
    },
    CUSTOM: {
        id: 1,
        displayedName: 'DEV_c',
        iconName: 'code',
        avalibleDialogs: [
            routingInfo.SANDBOX
        ],
        activeDialogs: [
            routingInfo.SANDBOX
        ]
    },
});
export const REQUEST_STATUS = Object.freeze({
    ok: {
        text: "OK"
    },
    wrongStatus: {
        text: "Wrong Status"
    },
    cannotSend: {
        text: "Cannot Send"
    }
});
export function syncDelay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
let uidVal = 0;
export function getUid() {
    uidVal = (uidVal + 1) % 100000000;
    return uidVal;
}
export function getHexFormatedDouble(val, minLenght) {
    const strHex = val.toString(16);
    const strSplit = [];
    for (let i = strHex.length - 1; i >= 0; i -= 2) {
        if (strHex >= 1) {
            strSplit.push(`${strHex[i]}${strHex[i - 1]}`);
        }
        else {
            strSplit.push(`0${strHex[i - 1]}`);
        }
    }
    while (strSplit.length * 2 < minLenght) {
        strSplit.push('00');
    }
    strSplit.reverse();
    return strSplit.join(' ');
}
export function getCommonDateFormat(dateTime) {
    if (!dateTime) {
        return '-';
    }
    if (typeof dateTime === 'string') {
        dateTime = new Date(dateTime);
    }
    const month = '' + (dateTime.getMonth() + 1);
    const day = '' + dateTime.getDate();
    const year = dateTime.getFullYear();
    return `${day.padStart(2, '0')}. ${month.padStart(2, '0')}. ${year}`;
}
/* export function getCommonWeaklyFormat() {

} */
export function getCommonTimeFormat(dateTime) {
    if (!dateTime) {
        return '-';
    }
    if (typeof dateTime === 'string') {
        dateTime = new Date(dateTime);
    }
    const hour = '' + dateTime.getHours();
    const minute = '' + dateTime.getMinutes();
    return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
}
export function getShortCombinatedTimeFormat(dateTime) {
    if (!dateTime) {
        return '-';
    }
    if (typeof dateTime === 'string') {
        dateTime = new Date(dateTime);
    }
    const month = '' + (dateTime.getMonth() + 1);
    const day = '' + dateTime.getDate();
    const hour = '' + dateTime.getHours();
    const minute = '' + dateTime.getMinutes();
    return `${day}. ${month}. ${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
}
export function displayFormatSensorId(strId) {
    return strId
        .match(/.{1,2}/g)
        .join(".");
}
let batchUUID = 10; // TODO
export function getNextBatchId() {
    batchUUID++;
    return batchUUID;
}
export function getCorectSufixIndex_wholeNum(val) {
    const num = Math.floor(val);
    if (val === 1) {
        return 0;
    }
    else if (val > 1 && val < 5) {
        return 1;
    }
    return 3;
}
export function getMinSuf_wholeNum(val) {
    const index = getCorectSufixIndex_wholeNum(val / 60);
    return index === 0 ? 'minuta' : index === 1 ? 'minuty' : 'minut';
}
export function getSecSuf_wholeNum(val) {
    const index = getCorectSufixIndex_wholeNum(val);
    return index === 0 ? 'sekunda' : index === 1 ? 'sekundy' : 'sekund';
}
function strCutTolen(str, len) {
    const maxFullStr = len + 3;
    return str.length <= maxFullStr ? str : `${str.substring(0, len)}...`;
}
export function genLabelFromMesurment(mes) {
    return printLabel(mes.static.id, displayFormatSensorId(mes.static.probe.id), `${(new Date().getMonth() + 1)
        .toString()
        .padEnd(2)} ${new Date().getFullYear()}`, mes.static.baseCustomeCom.name, mes.static.baseOwnerCom.name, mes.static.userEvidenceLabel);
}
function printLabel(listId, sensorId, calibrationTime, customer, user, tanixId) {
    const qrCode = listId;
    // tanixId = 'ONMB-06-1253-1011';
    const usedName_customer = (customer === undefined || customer === null) ? '-' : strCutTolen(customer, 35);
    const usedName_user = (user === undefined || user === null) ? '-' : strCutTolen(user, 35);
    const realTanixId = (tanixId === undefined || tanixId === null) ? '-' : tanixId;
    return `^XA
^CI28

^FX Image K2373
^FO480,230^GFA,1484,1484,14,,S02,S07,S0F,S0F8,R01FC,R03FC,R03FE,R07FF,R0IF,R0IF8,Q01IFC,:Q03IFE,Q07FDFF,Q07FCFF,Q0FF8FF8,P01FF07FC,:P03FE03FE,P07FC01FF,P07F801FF,P0FF800FF8,O01FFI07FC,O01FEI03FC,O03FE7FC3FE,O07KF1FF,O07KFCFF,O0OF8,N01OFC,:N03IF007IFE,N03FF8001JF,N07FEJ0JF,N0FFCJ07IF8,N0FF8J03IFC,M01FFK01FBFC,M03FFK01FBFE,M03FF8J01F9FF,M07FDK01FCFF,M0IF4J01FCFF8,M0FF9K01F87FC,L01FF9K01F83FC,L03JF8I01F83FE,L03FFDK01F81FF,L07IFK03F00FF8,L0KFAI03F00FF8,L0JF4AI07E007FC,K01FF3FB6I0FE003FE,K03FF3FCA001FC003FE,K03FE1FCA003F8001FF,K07FC0FF240FFJ0FF8,K0WF8,K0WFC,J01WFE,:J03XF,J07XF8,:J0FFBFCK03FCI01FFC,I01FF9FCK01FEI03FFE,I01FF0FEL0FEI07FFE,I03FE0FFL07FI0JF,I07FE07FL07F001JF8,I07FC07F8K03F003FEFF8,I0FF803F8K03F007FC7FC,001FF803FCK01F81FF83FE,001FF001FCK01F87FF01FE,003FE001FEK01F8FFE01FF,007FE001FEK01F8FFC78FF8,007FCI0FFK01F8FF8FC7F8,00FF8I07FK03F8FF1FE7FC,00FF8I07F8J03F87F1FE3FE,01FFJ03FCJ07F07E1FE3FE,03FEJ03FEJ0FF0181FE1FF,03FEJ01FF8001FF0039FE0FF8,07LF8FFC003FE007EFC0FF8,0MFC7FFC1FFC00FEI07FC,0MFC3LF801FFI03FE,1MFE1LF001FFI03FF,3NF0KFE001FFI01FF,3NF03JFCI0FEJ0FF87NF80JFJ07EJ0FFCOFC01FEK038J07FC,::::::L0707803F07C3FF1F,L070F007F8FE3FF3F8,L071E00738C73FE31C,L073C00E18C700C31C,L0778I0180701C01C,L07FJ0381E018078,L07F8I0701C038078,L07FCI0F00703001C,L079C001E00307I0C,L070E003C00386I0E,L070F00781C306070E,L0707007F8E70E039C,L070780FF8FE0E03F8,L0703C0FF83C0E00F,,^FS

^FX Image SCANLAB PRAHA
^FO480,70^GFA,1846,1846,26,,::::::::::M03C,M0C6,M083,L0101,L03018,L02008,:L0600C,L04004,I01C0400407,I0FFEI067FE,001807C002403,001I07832001,001J0E12001,001I08382001I03E200FE2006007E01FDFFJ03003FFE,00180080E2003I0E1E0383A007001F00707EJ03I0F0F8,I0800183I02I0C0E0701E007I0F80603CJ07I07078,I0C00701C006001C060E00E00FI0FC0203CJ07800703C,I0401C007004001C061E00600F800FC0203CJ0F800703C,I0203I0180C001E001E00200F8009E0203CJ0FC00703C,I030607C0C18001F003C0020178009F0203CJ0BC007038,I019C0FE073J0FE03CJ013C008F8203CI01BC00707,J0310FE118J07F03CJ033C0087C203CI011E007FC,J0610FE10CJ03FC3CJ021E0083E203CI031E007FE,J0C10FE106K0FE3CJ021E0081E203CI031F007078,I018C0FE123K07F3CJ060F0080F203CI020F00703C,I030607C141800101F3C00207FF0080FE03CI07FF00701C,I0603I0300C00180F1E0020D4F00807E03C01066F80701E,I0400C0030040018071E006080780803E03C01040780701E,I0C00701B0060018070E00E080780801E03C030C03C0703C,I08001C32002001C0E0701E180780800E03C070C03C0F83C,0018008E0200300131E03C323C07C1C00E07E1F1C03E0FCF8,001I083C20010011F800FE27E1FF7F0061JF3F0FF3FFC,001I01C72001,001I07012001,001807C006403,I07FCI067FC,L04004,:L0600CgK0FC7FJ0F9E04,L02008gK06339C06060C04,L02008gK06198C06060C0E,L01018gK06198C0F060C0E,L0181gL06318C0B060C06,M082gL07E1F003070C13,M046gL06019811860C13,M038gL06018C1F860C1F8,gU06018C21860C218,gU06038621C60C61C,gX08,,:::::::::^FS


^FX QRCODE

^FO620,190
^BQN,2,5
^FDQM,A${qrCode}^FS

^FX Top section kalibracni list
^FO30,80                                     
^GB290,50,2^FS
^CF0,18
^FO35,30^FDKalibrační list:^FS  
^CF0,25
^FO35,50^FV${listId}^FS     

^FO480,140
^GB290,50,2^FS
^CF0,30
^FO510,155^FV${listId}^FS



^FX Top section ID sond
^FO30,25
^GB290,50,2^FS
^CF0,15
^FO35,85^FDSONDA ID:^FS
^CF0,20
^FO35,105^FV${sensorId}^FS

^CF0,20
^FO480,30^FDSONDA ID:^FS
^FO570,30^FV${sensorId}^FS


^FX Section date
^FO30,135
^GB290,50,2^FS
^CF0,18
^FO35,140^FDKalibrace provedena:^FS
^CF0,25
^FO35,160^FV${calibrationTime}^FS

^FX Section Customer
^FO30,190
^GB290,50,2^FS
^CF0,18
^FO35,195^FDObjednavatel:^FS
^CF0,17
^FO35,220^FV${usedName_customer}^FS

^FX Section User
^FO30,245
^GB290,50,2^FS
^CF0,18
^FO35,250^FDPříjemce:^FS
^CF0,17
^FO35,275^FV${usedName_user}^FS

^FX Section User ID
^FO30,300
^GB290,50,2^FS
^CF0,18
^FO35,305^FDVlastní evidenční označení:^FS
^CF0,25
^FO35,325^FV${realTanixId}^FS

^FX Rounding
^FO10,10^GB780,380,2,,1^FS
^FO400,10^GB2,380,2^FS


^FX Web URL
^CF0,18
^FO30,360^FDwww.KALIBRACETEPLOMERU.cz^FS
^CF0,18
^FO510,360^FDwww.KALIBRACETEPLOMERU.cz^FS
^XZ`;
}
export function formatToExport(deviceId, listId, customer, ownerName, mesurment) {
    return {
        "KL": {
            "ID": listId,
            "inDate": "1/10/2021",
            "inTime": "15:04:34",
            "outDate": "1/30/2021",
            "sign": 1
        },
        "order": {
            "ID": "00002",
            "cust": {
                "orgName": customer.name,
                "address": customer.contatInfo.address,
                "phone": customer.contatInfo.phone,
                "email": customer.contatInfo.email,
                "user": ownerName
            },
            "device": {
                "name": "JoTio-EX",
                "factory": "JoTio Tech s.r.o.",
                "deviceID": "ASNibgYJvLnu",
                "probe": {
                    "custProbeID": "lednice 01",
                    "probeID": deviceId,
                    "NextDate": "2",
                    "probeType": "JO:T",
                    "resolution": "0.1",
                    "range": "(-50,125)",
                    "size": "5*50 mm",
                    "type": "2",
                    "coments": "Nové měřidlo"
                }
            }
        },
        "calibration": {
            "inLabDate": "1/15/2021",
            "inLabTime": "15:16:34",
            "startDate": "1/15/2021",
            "startTime": "15:20:34",
            "stopTime": "17:20:34",
            "employee": "Martin Míšek",
            "place": "0",
            "temperature": "23.7",
            "humidity": "70%",
            "etalon": {
                "id": "1",
                "type": "2",
                "equipment": "1"
            },
            /* "point": [
                {
                    "target": "-10",
                    "correction": "0",
                    "measure": [
                        {
                            "value": 1,
                            "etalon": 11
                        }
                    ]
                }
            ] */
            point: mesurment.map(measure => {
                return {
                    target: measure.targetTemp.toString(),
                    "correction": "0",
                    measure: measure.mesurmentList.map(dataPoint => {
                        return {
                            "value": dataPoint.value,
                            "etalon": dataPoint.etalon
                        };
                    })
                };
            })
        }
    };
}
